import { BasePrice, ExtendedPriceDto } from "../../../../models/product-v2";
import { ProductListVMResponse } from "../../../../models/product-v3";
import { ProductV2Adapter } from "../adapters/product-v2.adapter";
import { ProductV3Adapter } from "../adapters/product-v3.adapter";


export class ProductListMapper {
  static toVMResponse(res: any, isV2: boolean): ProductListVMResponse {
    return {
      items: isV2
        ? res.items.map(ProductV2Adapter.toListVM)
        : res.items.map(ProductV3Adapter.toListVM),
      total: res.page.totalElements
    };
  }

  static toVM(res: any, isV2: boolean): ProductListVMResponse {
    if (isV2) {

      return { 
        ...res,
        basePrice: res.basePrice ?? new BasePrice(),
        pricing: res.pricing ?? { base: new ExtendedPriceDto(), branches: [] },
        images: res.images ?? [],
        specifications: res.specifications ?? [],
        nutritionalWarnings: res.nutritionalWarnings ?? []
      };
    } else {
      // adaptar de V3 al mismo formato
      return {
        ...res,
        basePrice: res.basePrice ?? new BasePrice(),
        pricing: res.pricing ?? { base: new ExtendedPriceDto(), branches: [] },
        images: res.images ?? [],
        specifications: res.specifications ?? [],
        nutritionalWarnings: res.nutritionalWarnings ?? []
      };
    }
  }
}